<vc-badge
    [label]="status | taskStatus"
    [status]="status | taskBadgeStatus"
    [prefixIcon]="status | taskStatusIcon"
    class="body-small"></vc-badge>
